export default function AboutSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-secondary-50">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="max-w-[1280px] mx-auto">
          {/* Upper text area */}
          <div className="flex flex-col lg:flex-row lg:items-start gap-8 lg:gap-16">
            <div className="lg:w-1/3">
              <span className="inline-block text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
                About Pandabuy Sheet
              </span>
            </div>
            <div className="lg:w-2/3">
              <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight tracking-tight">
                Data-Driven Sourcing
                <br />
                for Modern Buyers
                <br />
                Worldwide
              </h2>
              <p className="mt-8 text-foreground-600 text-base leading-relaxed max-w-2xl">
                The <strong>pandabuyspreadsheet</strong> system was built to solve a common problem: inefficient product sourcing. Instead of manually browsing countless listings and comparing agents one by one, our spreadsheet-based approach organizes everything into structured, sortable, and filterable views. Each <strong>pandabuy spreadsheet</strong> is curated by experienced buyers who understand what makes a great product listing — from accurate sizing charts to reliable quality indicators. Whether you are a dropshipping beginner or an experienced reseller managing hundreds of orders per month, having a well-organized <strong>shopping agent spreadsheet</strong> saves time, reduces costly mistakes, and helps you spot trending products before your competitors do. Our <strong>product sourcing spreadsheet</strong> collections cover everything from sneakers and streetwear to accessories and home goods, with new lists added every week based on community feedback and market trend analysis.
              </p>
            </div>
          </div>

          {/* Lower image area */}
          <div className="mt-12 flex flex-col md:flex-row gap-4 md:gap-6">
            <div className="md:w-[40%] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20minimalist%20workspace%20with%20modern%20laptop%20displaying%20spreadsheet%20data%20alongside%20a%20notebook%20and%20coffee%20on%20a%20warm%20cream%20wooden%20desk%2C%20soft%20natural%20morning%20light%20streaming%20through%20a%20nearby%20window%2C%20editorial%20lifestyle%20photography%20with%20warm%20beige%20and%20cream%20tones%2C%20inviting%20and%20clean%20composition&width=800&height=600&seq=about-workspace-v2&orientation=landscape"
                alt="Pandabuy spreadsheet sourcing workspace setup"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="md:w-[60%] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20wide%20flat%20lay%20of%20diverse%20curated%20fashion%20products%20neatly%20organized%20in%20a%20grid%20pattern%20on%20a%20large%20cream%20textured%20surface%2C%20soft%20diffused%20overhead%20lighting%2C%20editorial%20product%20photography%20with%20cohesive%20warm%20neutral%20color%20palette%2C%20clean%20and%20balanced%20composition%20with%20thoughtful%20spacing&width=1200&height=600&seq=about-collection-v2&orientation=landscape"
                alt="Organized pandabuy product collection grid"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}